import { useI18n } from '../i18n';
import { resolveAppBuildInfo } from '../utils/appBuildInfo';
import styles from './AppBuildInfoTrigger.module.css';

type AppBuildInfoPopoverProps = {
  id?: string;
  className?: string;
};

export function AppBuildInfoPopover({ id, className }: AppBuildInfoPopoverProps) {
  const { t, language } = useI18n();
  const info = resolveAppBuildInfo(language);
  const rootClass = [styles.popover, className].filter(Boolean).join(' ');

  return (
    <div id={id} className={rootClass} role="status">
      <div className={styles.popoverRow}>
        <span className={styles.popoverLabel}>{t('profile.hub.buildInfoEnvironment')}</span>
        <span className={styles.popoverValue}>{info.environmentLabel}</span>
      </div>
      <div className={styles.popoverRow}>
        <span className={styles.popoverLabel}>{t('profile.hub.buildInfoUpdated')}</span>
        <span className={styles.popoverValue}>
          {info.updatedAtDisplay ?? t('profile.hub.buildInfoUnknown')}
        </span>
      </div>
      <div className={styles.popoverRow}>
        <span className={styles.popoverLabel}>{t('profile.hub.buildInfoVersion')}</span>
        <span className={styles.popoverValue}>{info.version}</span>
      </div>
      <div className={styles.popoverRow}>
        <span className={styles.popoverLabel}>{t('profile.hub.buildInfoPlayVersion')}</span>
        <span className={styles.popoverValue} dir="ltr">
          {info.playVersionName}
        </span>
      </div>
    </div>
  );
}
